import React, { useState, useEffect } from "react";

const CountdownTimer = ({ initialMinutes = 0, initialSeconds = 0, setIsDisabled }: any) => {
    const [time, setTime] = useState({
        minutes: initialMinutes,
        seconds: initialSeconds,
    });

    useEffect(() => {
        let countdownInterval = setInterval(() => {
            const { minutes, seconds } = time;

            if (minutes === 0 && seconds === 0) {
                clearInterval(countdownInterval);
                setIsDisabled(false);
            } else if (seconds === 0) {
                setTime({
                    minutes: minutes - 1,
                    seconds: 59,
                });
            } else {
                setTime({
                    minutes,
                    seconds: seconds - 1,
                });
            }
        }, 1000);

        return () => clearInterval(countdownInterval);
    }, [time]);

    return (
        <div>
            Resend OTP in {time.minutes < 10 ? `0${time.minutes}` : time.minutes}:
            {time.seconds < 10 ? `0${time.seconds}` : time.seconds} seconds
        </div>
    );
};

export default CountdownTimer;